// extracted by mini-css-extract-plugin
export default {"inputError":"InputError_inputError__FA9yn"};